/* esm.sh - three-mesh-bvh@0.9.10/src/core/build/geometryUtils */
export * from "/*three-mesh-bvh@0.9.10/esnext/src/core/build/geometryUtils.mjs";
